module.exports = __webpack_public_path__ + "cf8773e60a482c3752c2b3700bd25db7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/Black2.jpg
// module id = 7
// module chunks = 0